'use client'

import { MessageCircle } from 'lucide-react'
import { toast } from 'sonner'
import { openSupportChat } from '@/lib/support-chat'

export function OpenChatBlock() {
  function handleOpenChat() {
    if (openSupportChat()) {
      return
    }

    toast.error(
      'O chat não está disponível no momento. Tente novamente em instantes ou fale conosco por e-mail.'
    )
  }

  return (
    <button
      className="flex h-[7.0175rem] w-full flex-1 cursor-pointer flex-col items-center justify-center gap-1 rounded-md bg-[#1036F2] text-center font-semibold text-white text-xl transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.97] motion-reduce:transition-none"
      onClick={handleOpenChat}
      type="button"
    >
      <MessageCircle aria-hidden="true" className="size-6" />
      Converse agora
    </button>
  )
}
